import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { momentFromApiDate } from 'Utils/date/apiDate';
import { Title } from 'Components/frameworks/title/Title';
type Props = {
  className?: string;
  id?: string;
  stay: StayEntity;
  title: string;
};

const formatDate = (date: APIDate) => momentFromApiDate(date).format('DD MMM');

export const StayLayerHeader = ({ className, id, stay, title }: Props) => (
  <div className={classnames('flex justify-center gap-20 p-15', className)}>
    <Title id={id} theme="title-brand-n3">
      {title}
    </Title>
    <div className="hidden font-bold text-mediumGrey md:block">
      <span className="me-15">{stay.product?.name}</span>
      {`${formatDate(stay.dates?.startDate)} - ${formatDate(stay.dates?.endDate)}`}
    </div>
  </div>
);
